import { useState, type ReactNode } from 'react';
import { PageMetaSetContext, PageMetaValueContext, type StoredPageMeta } from './usePageMeta';

/** Holds the TopBar meta pages set with usePageMeta. Pages only see the (stable) setter. */
export function PageMetaProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<StoredPageMeta | null>(null);
  return (
    <PageMetaSetContext.Provider value={setMeta}>
      <PageMetaValueContext.Provider value={meta}>{children}</PageMetaValueContext.Provider>
    </PageMetaSetContext.Provider>
  );
}
